import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    no: {
        translation: {
            home: "Hjem",
            about: "Om meg",
            skills: "Ferdigheter",
            projects: "Prosjekter",
            contact: "Kontakt",
            email: "E-post",
            software_developer: "Programvareutvikler",
            age_info: "29 år gammel programvare utvikler.",
            place_info: " Fra Eidsvoll, bosatt i Oslo.",
            education: "Utdannet ved Universitetet i Oslo.",
            programming_languages: "Programmeringsspråk",
            frameworks_libraries: "Rammeverk og biblioteker",
            databases: "Databaser",
            tools_platforms: "Verktøy og plattformer",
            embedded: "Innebygde systemer",
            system: "System Programmering",
            view_project: "Se prosjekt",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Organizer app for personlig bruk. Android native med Kotlin og lokal database.",
            project_title_homepage: "Hjemmeside",
            project_description_homepage: "Dette nettstedet. Laget med React og Bootstrap.",
            project_title_job_tracker: "Job Tracker",
            project_description_job_tracker: "Program for å holde oversikt over søkte stillinger.",
            project_title_system_monitor: "System Monitor",
            project_description_system_monitor: "Linux system monitor CLI verktøy. Laget med Python."

        }
    },
    en: {
        translation: {
            home: "Home",
            about: "About",
            skills: "Skills",
            projects: "Projects",
            contact: "Contact",
            email: "Email",
            software_developer: "Software Developer",
            age_info: "29 years old software developer.",
            place_info: " From Eidsvoll, living in Oslo.",
            education: "Educated at the University of Oslo.",
            programming_languages: "Programming Languages",
            frameworks_libraries: "Frameworks and Libraries",
            databases: "Databases",
            tools_platforms: "Tools and Platforms",
            embedded: "Embedded Systems",
            system: "System Programming",
            view_project: "View Project",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Organizer app for personal use. Android native with Kotlin and local database.",
            project_title_homepage: "Homepage",
            project_description_homepage: "This website. Built with React and Bootstrap.",
            project_title_job_tracker: "Job Tracker",
            project_description_job_tracker: "Job tracker app for personal use.",
            project_title_system_monitor: "System Monitor",
            project_description_system_monitor: "Linux system monitor CLI tool. Built with Python."

        }
    },
    es: {
        translation: {
            home: "Inicio",
            about: "Acerca de",
            skills: "Habilidades",
            projects: "Proyectos",
            contact: "Contacto",
            email: "Correo electrónico",
            software_developer: "Desarrollador de Software",
            age_info: "Desarrollador de software de 29 años.",
            place_info: " De Eidsvoll, viviendo en Oslo.",
            education: "Educado en la Universidad de Oslo.",
            programming_languages: "Lenguajes de Programación",
            frameworks_libraries: "Frameworks y Bibliotecas",
            databases: "Bases de Datos",
            tools_platforms: "Herramientas y Plataformas",
            embedded: "Sistemas Empotrados",
            system: "Programación de Sistemas",
            view_project: "Ver Proyecto",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Organizer app para uso personal. Android nativo con Kotlin y base de datos local.",
            project_title_homepage: "Página de inicio",
            project_description_homepage: "Este sitio web. Construido con React y Bootstrap.",
            project_title_job_tracker: "Rastreador de Empleo",
            project_description_job_tracker: "Aplicación de rastreo de empleo para uso personal.",
            project_title_system_monitor: "Monitor del Sistema",
            project_description_system_monitor: "Herramienta CLI de monitorización del sistema Linux. Construida con Python."
        }
    },
    it: {
        translation: {
            home: "Home",
            about: "Chi sono",
            skills: "Competenze",
            projects: "Progetti",
            contact: "Contatti",
            email: "Email",
            software_developer: "Sviluppatore di Software",
            age_info: "Sviluppatore software di 29 anni.",
            place_info: " Da Eidsvoll, vive a Oslo.",
            education: "Laurato presso l'Università di Oslo.",
            programming_languages: "Linguaggi di Programmazione",
            frameworks_libraries: "Framework e Librerie",
            databases: "Database",
            tools_platforms: "Strumenti e Piattaforme",
            embedded: "Sistemi Embedded",
            system: "Programmazione di Sistema",
            view_project: "Vedi Progetto",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Organizer app per uso personale. Android nativo con Kotlin e database locale.",
            project_title_homepage: "Homepage",
            project_description_homepage: "Questo sito web. Costruito con React e Bootstrap.",
            project_title_job_tracker: "Job Tracker",
            project_description_job_tracker: "App per tracciare le offerte di lavoro per uso personale.",
            project_title_system_monitor: "System Monitor",
            project_description_system_monitor: "Strumento CLI per monitorare il sistema Linux. Costruito con Python."
        }
    },
    de: {
        translation: {
            home: "Startseite",
            about: "Über mich",
            skills: "Fähigkeiten",
            projects: "Projekte",
            contact: "Kontaktieren Sie mich",
            email: "E-Mail",
            software_developer: "Softwareentwickler",
            age_info: "29-jähriger Softwareentwickler.",
            place_info: " Aus Eidsvoll, wohnhaft in Oslo.",
            education: "Studiert an der Universität Oslo.",
            programming_languages: "Programmiersprachen",
            frameworks_libraries: "Frameworks und Bibliotheken",
            databases: "Datenbanken",
            tools_platforms: "Werkzeuge und Plattformen",
            embedded: "Eingebettete Systeme",
            system: "Systemprogrammierung",
            view_project: "Projekt ansehen",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Organizer app für den persönlichen Gebrauch. Native Android-Anwendung mit Kotlin und lokaler Datenbank.",
            project_title_homepage: "Homepage",
            project_description_homepage: "Diese Website. Erstellt mit React und Bootstrap.",
            project_title_job_tracker: "Job Tracker",
            project_description_job_tracker: "Job-Tracker-App für den persönlichen Gebrauch.",
            project_title_system_monitor: "System Monitor",
            project_description_system_monitor: "Linux-Systemmonitor-CLI-Tool. Entwickelt mit Python."
        }
    },
    ru: {
        translation: {
            home: "Главная",
            about: "Обо мне",
            skills: "Навыки",
            projects: "Проекты",
            contact: "Контакты",
            email: "Электронная почта",
            software_developer: "Разработчик программного обеспечения",
            age_info: "29-летний разработчик программного обеспечения.",
            place_info: " Из Эйдсволля, проживающий в Осло.",
            education: "Окончил в Университете Осло.",
            programming_languages: "Языки программирования",
            frameworks_libraries: "Фреймворки и библиотеки",
            databases: "Базы данных",
            tools_platforms: "Инструменты и платформы",
            embedded: "Встроенные системы",
            system: "Системное программирование",
            view_project: "Посмотреть проект",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Organizer app для личного использования. Нативное приложение Android с Kotlin и локальной базой данных.",
            project_title_homepage: "Homepage",
            project_description_homepage: "Этот сайт. Создан с использованием React и Bootstrap.",
            project_title_job_tracker: "Job Tracker",
            project_description_job_tracker: "Приложение для отслеживания вакансий для личного использования.",
            project_title_system_monitor: "System Monitor",
            project_description_system_monitor: "Инструмент командной строки для мониторинга системы Linux. Создан с помощью Python."
        }
    },
    ar: {
        translation: {
            home: "الصفحة الرئيسية",
            about: "معلومات عنا",
            skills: "المهارات",
            projects: "المشاريع",
            contact: "اتصل",
            email: "البريد الإلكتروني",
            software_developer: "مطور برمجيات",
            age_info: "مطور برمجيات يبلغ من العمر 29 عامًا.",
            place_info: " من إيدسفول، يعيش في أوسلو.",
            education: "تعليم في جامعة أوسلو",
            programming_languages: "لغات البرمجة",
            frameworks_libraries: "الأطر والمكتبات",
            databases: "قواعد البيانات",
            tools_platforms: "الأدوات والمنصات",
            embedded: "الأنظمة المدمجة",
            system: "برمجة النظام",
            view_project: "عرض المشروع",
            project_title_organizer: "تطبيق المنظم",
            project_description_organizer: "تطبيق منظم للاستخدام الشخصي. أندرويد أصلي مع كوتلن وقاعدة بيانات محلية.",
            project_title_homepage: "الصفحة الرئيسية",
            project_description_homepage: "هذا الموقع. تم بناؤه باستخدام React و Bootstrap.",
            project_title_job_tracker: "متعقب الوظائف",
            project_description_job_tracker: "تطبيق تتبع الوظائف للاستخدام الشخصي.",
            project_title_system_monitor: "مراقب النظام",
            project_description_system_monitor: "أداة CLI لمراقبة نظام Linux. تم بناؤه باستخدام Python."
        }
    },
    zh: {
        translation: {
            home: "首页",
            about: "关于我",
            skills: "技能",
            projects: "项目",
            contact: "联系",
            email: "电子邮件",
            software_developer: "软件开发人员",
            age_info: "29岁软件开发人员。",
            place_info: " 来自Eidsvoll，现居奥斯陆。",
            education: "毕业于奥斯陆大学",
            programming_languages: "编程语言",
            frameworks_libraries: "框架和库",
            databases: "数据库",
            tools_platforms: "工具和平台",
            embedded: "嵌入式系统",
            system: "系统编程",
            view_project: "查看项目",
            project_title_organizer: "Organizer 应用",
            project_description_organizer: "个人使用的Organizer应用。使用Kotlin和本地数据库的原生Android应用。",
            project_title_homepage: "主页",
            project_description_homepage: "这个网站。使用React和Bootstrap构建。",
            project_title_job_tracker: "工作跟踪器",
            project_description_job_tracker: "个人使用的工作跟踪器应用。",
            project_title_system_monitor: "系统监视器",
            project_description_system_monitor: "Linux系统监视器CLI工具。使用Python构建。"
        }
    },
    fr: {
        translation: {
            home: "Accueil",
            about: "À propos",
            skills: "Compétences",
            projects: "Projets",
            contact: "Contact",
            email: "Email",
            software_developer: "Développeur de logiciels",
            age_info: "Développeur de logiciels de 29 ans.",
            place_info: " D'Eidsvoll, vivant à Oslo.",
            education: "Formé à l'Université d'Oslo.",
            programming_languages: "Langages de programmation",
            frameworks_libraries: "Frameworks et bibliothèques",
            databases: "Bases de données",
            tools_platforms: "Outils et plates-formes",
            embedded: "Systèmes embarqués",
            system: "Programmation système",
            view_project: "Voir le projet",
            project_title_organizer: "Organizer App",
            project_description_organizer: "Application Organizer pour un usage personnel. Android natif avec Kotlin et base de données locale.",
            project_title_homepage: "Page d'accueil",
            project_description_homepage: "Ce site web. Construit avec React et Bootstrap.",
            project_title_job_tracker: "Suivi de travail",
            project_description_job_tracker: "Application de suivi de travail pour un usage personnel.",
            project_title_system_monitor: "Moniteur système",
            project_description_system_monitor: "Outil CLI de surveillance du système Linux. Construit avec Python."
        }
    },
};

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage'],
        },
    });

export default i18next;